import React from "react";
import { useForm } from "react-hook-form";
import { createSmeParticipant } from "../../api/user"

const CreateParticipants = ({changeModalPopupDisplayData}) => {

    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = (data) => {


        let user_id = sessionStorage.getItem("user_id");

        if(user_id){

            data.id = 0;
            data.sme_id = user_id

            let sme_participant = createSmeParticipant(data)

            sme_participant.then((value) => {

                if(value.data.response === "success") {
                    alert("Successfully added participant")
                    changeModalPopupDisplayData('sme_add_participant')
                }else{

                    alert(value.data.message)
                }
            })
        }
    

    }
    return(

        <div className="popup_div_favorite edit_account_form p-5">
            <div className="update_profile_div">
                <form onSubmit={handleSubmit(onSubmit)}>
                {/* <div className="edit_account float-right">
                    <a href="" className="edit_close"><img src="images/edit_arrow.svg" alt="" /></a>
                </div> */}
                <h3 className="text-center">Add New Participants</h3>
                <hr />
                <div className="mt-4">
                    
                    <div className="participant_box p-4 mb-4">
                    <div className="row">
                        <div className="col-sm-6 mb-3">
                        <label>First Name</label>
                        <input type="text" placeholder="First Name" data-vv-as="first name" name="first_name"
                            className="form-control" aria-required="true" aria-invalid="false" {...register("first_name",{ required : true})}/> 
                           {errors.first_name && <span className="is-danger">The first name field is required</span>}
                        </div>
                        <div className="col-sm-6 mb-3">
                        <label>Last Name</label>
                        <input type="text" placeholder="Last Name"  name="last_name"
                            className="form-control" aria-required="true" aria-invalid="false"  {...register("last_name",{ required : true})}/>
                             {errors.last_name && <span className="is-danger">The last name field is required</span>}
                        </div>
                        <div className="col-sm-12">
                        <label>Email</label>
                        <input type="email" placeholder="Email"  name="email"
                            className="form-control" aria-required="true" aria-invalid="false"  {...register("email",{ required : true})}/>
                            {errors.email && <span className="is-danger">The email field is required</span>}
                        </div>
                    </div>
                    </div>
                </div>
                <div className="form-group text-center pt-4"><button type="submit" className="btn login_btn">Save Participants</button></div>
                </form>
            </div>
        </div>
    )
}

export default CreateParticipants